const steps = [
  {
    element: '.search-form',
    popover: {
      title: '搜索运费',
      description: '输入地点查找历史运费',
      position: 'bottom'
    }
  },
  {
    element: '.el-icon-plus',
    popover: {
      title: '添加栏目',
      description: '点击这里新建添加栏目',
      position: 'left'
    }
  }
]

export default steps
